import { noNewOrReviewCommentsExists } from "./noNewOrReviewCommentsExists";

export const changePostmortemStatusInStatusBar = (
  changeStatus,
  currState,
  postmortemState,
  priority,
  edSignedOff
) => {
  switch (currState) {
    case "DRAFT":
      // No automatic transition from DRAFT - user must explicitly submit for Leadership Review
      break;

    case "LEADERSHIP_REVIEW":
      // Check if all comments are resolved before transitioning to DONE
      if (noNewOrReviewCommentsExists(postmortemState)) {
        changeStatus({
          type: "HANDLE EDITOR CHANGE",
          field: "postmortemCurrentStatus",
          payload: { currentState: "DONE" },
        });
      }
      break;

    case "DONE":
      break;

    default:
      break;
  }
};
